// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#AdminUserInquiryLog {
  /* よくある質問生成モーダル */
  /* FAQ表示カード */
}
#AdminUserInquiryLog .inquiry-toolbar {
  width: 100%;
  flex-wrap: wrap;
  row-gap: 8px;
}
#AdminUserInquiryLog .search-input-area .search-inquiry-id {
  min-width: 200px;
}
#AdminUserInquiryLog .search-input-area .search-button {
  min-width: 72px;
}
#AdminUserInquiryLog .faq-download-button {
  min-width: 220px;
}
#AdminUserInquiryLog .inquiry-date-area {
  position: relative;
}
#AdminUserInquiryLog .calender-dialog {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  padding: 8px;
  background-color: transparent;
  z-index: var(--z-index-local-over-2);
}
#AdminUserInquiryLog .back-button {
  min-width: 140px;
}
#AdminUserInquiryLog .detail-info-card,
#AdminUserInquiryLog .detail-chatlog-card {
  width: 100%;
}
#AdminUserInquiryLog .detail-row {
  width: 100%;
}
#AdminUserInquiryLog .detail-summary-row {
  width: 100%;
  flex-wrap: wrap;
}
#AdminUserInquiryLog .detail-summary-cell {
  flex: 1 1;
  min-width: 160px;
}
#AdminUserInquiryLog .detail-summary-cell:nth-child(2) {
  flex: 3 1;
}
#AdminUserInquiryLog .detail-summary-cell:nth-child(3) {
  flex: none;
  margin-left: auto;
}
#AdminUserInquiryLog .detail-label {
  width: auto;
  flex-shrink: 0;
}
#AdminUserInquiryLog .detail-value {
  flex: 1 1;
  word-break: break-word;
  white-space: pre-wrap;
}
#AdminUserInquiryLog .detail-value-pre {
  white-space: pre-wrap;
  line-height: 1.6;
}
#AdminUserInquiryLog .scroll-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 64px;
  height: 64px;
  z-index: var(--z-index-local-over-5);
}
#AdminUserInquiryLog .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
#AdminUserInquiryLog .modal-overlay .background-gray {
  background-color: #f9f9f9;
  padding: 8px 16px;
}
#AdminUserInquiryLog .modal-content {
  background: #fff;
  width: 90%;
  max-width: 800px;
  height: 90%;
  max-height: 800px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
#AdminUserInquiryLog .modal-header {
  height: 64px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
}
#AdminUserInquiryLog .modal-header .text-size-h2 {
  font-weight: 600;
  font-size: 1.25rem;
}
#AdminUserInquiryLog .modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background-color: #f9f9f9;
}
#AdminUserInquiryLog .modal-body .markdown-content {
  background: #fff;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}
#AdminUserInquiryLog .modal-footer {
  height: 64px;
  padding: 0 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
}
#AdminUserInquiryLog .faq-generating {
  flex: 1 1;
  padding: 48px 24px;
}
#AdminUserInquiryLog .faq-loading-badge {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background-color: var(--primary-color-main, #1F3A5F);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
#AdminUserInquiryLog .faq-loading-badge .loading-box {
  --base-size: 40px;
}
#AdminUserInquiryLog .faq-body {
  background-color: #f5f7fa;
}
#AdminUserInquiryLog .faq-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border-left: 4px solid var(--primary-color-main, #1F3A5F);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
#AdminUserInquiryLog .faq-card-meta {
  flex-wrap: wrap;
  gap: 8px;
}
#AdminUserInquiryLog .faq-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}
#AdminUserInquiryLog .faq-badge-category {
  background: #E8EEF7;
  color: #1F3A5F;
  border: 1px solid #c8d4e6;
}
#AdminUserInquiryLog .faq-badge-frequency {
  border: 1px solid transparent;
}
#AdminUserInquiryLog .faq-badge-frequency.level-高 {
  background: #fde2e2;
  color: #b53737;
  border-color: #f1b3b3;
}
#AdminUserInquiryLog .faq-badge-frequency.level-中 {
  background: #fff3d4;
  color: #8a6a16;
  border-color: #f0d99a;
}
#AdminUserInquiryLog .faq-badge-frequency.level-低 {
  background: #e3f0e0;
  color: #3f7a3a;
  border-color: #b9d7b4;
}
#AdminUserInquiryLog .faq-card-question,
#AdminUserInquiryLog .faq-card-answer {
  width: 100%;
  align-items: flex-start;
  gap: 12px;
}
#AdminUserInquiryLog .faq-marker {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}
#AdminUserInquiryLog .faq-marker.question {
  background: #1F3A5F;
  color: #ffffff;
}
#AdminUserInquiryLog .faq-marker.answer {
  background: #e8eef7;
  color: #1F3A5F;
  border: 1px solid #c8d4e6;
}
#AdminUserInquiryLog .faq-card-question-text {
  font-size: 15px;
  font-weight: 700;
  color: #1F3A5F;
  line-height: 1.5;
  padding-top: 3px;
  word-break: break-word;
}
#AdminUserInquiryLog .faq-card-answer-text {
  font-size: 14px;
  color: #333333;
  line-height: 1.7;
  padding-top: 4px;
  white-space: pre-wrap;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserInquiryLog.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EA+FI,iBAAA;EA8FA,aAAA;AAzLJ;AAHI;EACI,WAAA;EACA,eAAA;EACA,YAAA;AAKR;AADQ;EACI,gBAAA;AAGZ;AAAQ;EACI,eAAA;AAEZ;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,kBAAA;AADR;AAII;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,oCAAA;AAFR;AAKI;EACI,gBAAA;AAHR;AAMI;;EAEI,WAAA;AAJR;AAOI;EACI,WAAA;AALR;AAQI;EACI,WAAA;EACA,eAAA;AANR;AASI;EACI,SAAA;EACA,gBAAA;AAPR;AAUQ;EACI,SAAA;AARZ;AAWQ;EACI,UAAA;EACA,iBAAA;AATZ;AAaI;EACI,WAAA;EACA,cAAA;AAXR;AAcI;EACI,SAAA;EACA,sBAAA;EACA,qBAAA;AAZR;AAeI;EACI,qBAAA;EACA,gBAAA;AAbR;AAgBI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EAEA,oCAAA;AAhBR;AAoBI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAlBR;AAoBQ;EACI,yBAAA;EACA,iBAAA;AAlBZ;AAsBI;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AApBR;AAuBI;EACI,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;AArBR;AAuBQ;EACI,gBAAA;EACA,kBAAA;AArBZ;AAyBI;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AAvBR;AAyBQ;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AAvBZ;AA2BI;EACI,YAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAzBR;AA4BI;EACI,SAAA;EACA,kBAAA;AA1BR;AA8BI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5BR;AA+BQ;EACI,iBAAA;AA7BZ;AAkCI;EACI,yBAAA;AAhCR;AAmCI;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,yDAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjCR;AAoCI;EACI,eAAA;EACA,QAAA;AAlCR;AAqCI;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnCR;AAsCI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AApCR;AAuCI;EACI,6BAAA;AArCR;AAuCQ;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;AArCZ;AAuCQ;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;AArCZ;AAuCQ;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;AArCZ;AAyCI;;EAEI,WAAA;EACA,uBAAA;EACA,SAAA;AAvCR;AA0CI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAxCR;AA0CQ;EACI,mBAAA;EACA,cAAA;AAxCZ;AA0CQ;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AAxCZ;AA4CI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AA1CR;AA6CI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AA3CR","sourcesContent":["#AdminUserInquiryLog {\n    .inquiry-toolbar {\n        width: 100%;\n        flex-wrap: wrap;\n        row-gap: 8px;\n    }\n\n    .search-input-area {\n        .search-inquiry-id {\n            min-width: 200px;\n        }\n\n        .search-button {\n            min-width: 72px;\n        }\n    }\n\n    .faq-download-button {\n        min-width: 220px;\n    }\n\n    .inquiry-date-area {\n        position: relative;\n    }\n\n    .calender-dialog {\n        position: absolute;\n        top: 100%;\n        right: 0;\n        margin-top: 8px;\n        padding: 8px;\n        background-color: transparent;\n        z-index: var(--z-index-local-over-2);\n    }\n\n    .back-button {\n        min-width: 140px;\n    }\n\n    .detail-info-card,\n    .detail-chatlog-card {\n        width: 100%;\n    }\n\n    .detail-row {\n        width: 100%;\n    }\n\n    .detail-summary-row {\n        width: 100%;\n        flex-wrap: wrap;\n    }\n\n    .detail-summary-cell {\n        flex: 1 1 0;\n        min-width: 160px;\n\n        // 番号:概要:日時 = 1:3:1 の比率で横幅を配分\n        &:nth-child(2) {\n            flex: 3 1 0;\n        }\n\n        &:nth-child(3) {\n            flex: none;\n            margin-left: auto;\n        }\n    }\n\n    .detail-label {\n        width: auto;\n        flex-shrink: 0;\n    }\n\n    .detail-value {\n        flex: 1;\n        word-break: break-word;\n        white-space: pre-wrap;\n    }\n\n    .detail-value-pre {\n        white-space: pre-wrap;\n        line-height: 1.6;\n    }\n\n    .scroll-button {\n        position: fixed;\n        bottom: 16px;\n        right: 16px;\n\n        width: 64px;\n        height: 64px;\n\n        z-index: var(--z-index-local-over-5);\n    }\n\n    /* よくある質問生成モーダル */\n    .modal-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100vw;\n        height: 100vh;\n        background-color: rgba(0, 0, 0, 0.5);\n        z-index: 9999;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .background-gray {\n            background-color: #f9f9f9;\n            padding: 8px 16px;\n        }\n    }\n\n    .modal-content {\n        background: #fff;\n        width: 90%;\n        max-width: 800px;\n        height: 90%;\n        max-height: 800px;\n        border-radius: 8px;\n        display: flex;\n        flex-direction: column;\n        box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    }\n\n    .modal-header {\n        height: 64px;\n        padding: 0 24px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border-bottom: 1px solid #e0e0e0;\n\n        .text-size-h2 {\n            font-weight: 600;\n            font-size: 1.25rem;\n        }\n    }\n\n    .modal-body {\n        flex: 1;\n        overflow-y: auto;\n        padding: 24px;\n        background-color: #f9f9f9;\n\n        .markdown-content {\n            background: #fff;\n            padding: 24px;\n            border-radius: 4px;\n            box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n            line-height: 1.7;\n            white-space: pre-wrap;\n            word-break: break-word;\n        }\n    }\n\n    .modal-footer {\n        height: 64px;\n        padding: 0 24px;\n        border-top: 1px solid #e0e0e0;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 16px;\n    }\n\n    .faq-generating {\n        flex: 1;\n        padding: 48px 24px;\n    }\n\n    // primary色の円形バッジに LoadingBox を載せて視認性を確保 (AdminUserChatReport の primary ボタン内 LoadingBox と同じ見せ方)\n    .faq-loading-badge {\n        width: 88px;\n        height: 88px;\n        border-radius: 50%;\n        background-color: var(--primary-color-main, #1F3A5F);\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        // LoadingBox の既定スピナー色変数が解決できない場合は currentColor (白) にフォールバックされ視認性が保たれる\n        .loading-box {\n            --base-size: 40px;\n        }\n    }\n\n    /* FAQ表示カード */\n    .faq-body {\n        background-color: #f5f7fa;\n    }\n\n    .faq-card {\n        background: #ffffff;\n        border-radius: 8px;\n        padding: 20px 24px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n        border-left: 4px solid var(--primary-color-main, #1F3A5F);\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n    }\n\n    .faq-card-meta {\n        flex-wrap: wrap;\n        gap: 8px;\n    }\n\n    .faq-badge {\n        display: inline-flex;\n        align-items: center;\n        padding: 4px 10px;\n        border-radius: 999px;\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 1.4;\n    }\n\n    .faq-badge-category {\n        background: #E8EEF7;\n        color: #1F3A5F;\n        border: 1px solid #c8d4e6;\n    }\n\n    .faq-badge-frequency {\n        border: 1px solid transparent;\n\n        &.level-高 {\n            background: #fde2e2;\n            color: #b53737;\n            border-color: #f1b3b3;\n        }\n        &.level-中 {\n            background: #fff3d4;\n            color: #8a6a16;\n            border-color: #f0d99a;\n        }\n        &.level-低 {\n            background: #e3f0e0;\n            color: #3f7a3a;\n            border-color: #b9d7b4;\n        }\n    }\n\n    .faq-card-question,\n    .faq-card-answer {\n        width: 100%;\n        align-items: flex-start;\n        gap: 12px;\n    }\n\n    .faq-marker {\n        width: 28px;\n        height: 28px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 13px;\n        font-weight: 700;\n        flex-shrink: 0;\n\n        &.question {\n            background: #1F3A5F;\n            color: #ffffff;\n        }\n        &.answer {\n            background: #e8eef7;\n            color: #1F3A5F;\n            border: 1px solid #c8d4e6;\n        }\n    }\n\n    .faq-card-question-text {\n        font-size: 15px;\n        font-weight: 700;\n        color: #1F3A5F;\n        line-height: 1.5;\n        padding-top: 3px;\n        word-break: break-word;\n    }\n\n    .faq-card-answer-text {\n        font-size: 14px;\n        color: #333333;\n        line-height: 1.7;\n        padding-top: 4px;\n        white-space: pre-wrap;\n        word-break: break-word;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
